/* global am4core, bocAmchart4, am4lang_fr_FR, am4geodata_lang_FR, am4lang_en, gaVars, gtag, chartLanguage */

/**
 * Apply BOC settings to a chart object, after it has been created.
 * This is used for all the properties that can't be defined as json properties
 * @param {am4charts.XYChart} chart The chart object
 * @returns {void}
 */
bocAmchart4.applyBocSettingsObject = function (chart) {
    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Running applyBosSettingsObject:",
            bocAmchart4.debugClone(chart),
            "Setting catch all events handlers for dataSource and Responsive, visible only in 'verbose' inspector mode"
        );

        chart.events.onAll(function (eventName, event) {
            // eslint-disable-next-line no-console
            console.debug("chart events:", eventName, event);
        });
        if (typeof chart.legend === "object") {
            chart.legend.events.onAll(function (eventName, event) {
                // eslint-disable-next-line no-console
                console.debug("legend events:", eventName, event);
            });
        }

        chart.dataSource.events.onAll(function (eventName, event) {
            // eslint-disable-next-line no-console
            console.debug("chart.dataSource events:", eventName, event);
        });

        chart.responsive.events.onAll(function (eventName, event) {
            // eslint-disable-next-line no-console
            console.debug("chart.responsive events:", eventName, event);
        });
    }

    if (chart.bocSettings.args.hasOwnProperty("objectcallback")) {
        if (typeof window[chart.bocSettings.args.objectcallback] === "function") {
            if (bocAmchart4.debug(chart)) {
                // eslint-disable-next-line no-console
                console.groupCollapsed(chart.bocSettings.id + " running objectcallback " + chart.bocSettings.args.objectcallback);
                // eslint-disable-next-line no-console
                console.log(window[chart.bocSettings.args.objectcallback].toString());
                // eslint-disable-next-line no-console
                console.groupEnd();
            }
            window[chart.bocSettings.args.objectcallback](chart);
        } else {
            // eslint-disable-next-line no-console
            console.log(chart.bocSettings.id + " did not find object callback function " + chart.bocSettings.args.objectcallback);
        }
    }

    // Set locale
    /* eslint-disable camelcase */
    if (chartLanguage === "fr") {
        if (typeof am4lang_fr_FR !== 'undefined') {
            chart.language.locale = am4lang_fr_FR;
        }
        if (typeof am4geodata_lang_FR !== 'undefined') {
            chart.geodataNames = am4geodata_lang_FR;
        }
    } else {
        if (typeof am4lang_en !== 'undefined') {
            chart.language.locale = am4lang_en;
        }
    }
    /* eslint-enable camelcase */

    chart.exporting.useWebFonts = false;

    // Hide scrollbar when printing
    chart.exporting.events.on("exportstarted", function (ev) {
        if (ev.format === "print") {
            if (typeof chart.scrollbarX !== 'undefined') {
                chart.scrollbarX.exportable = false;
            }

            if (typeof chart.scrollbarY !== 'undefined') {
                chart.scrollbarY.exportable = false;
            }
        }
    });

    // Add chart exporting button
    if (chart.bocSettings.addExport === true && chart.bocSettings.args["addexport"] !== 'false') {
        chart.exporting.menu = new am4core.ExportMenu();
        bocAmchart4.updateExportMenu(chart);
        //Allows exporter to be visible without covering the chart
        chart.exporting.menu.container.style.overflow = 'visible';
    }

    bocAmchart4.initChartVars(chart);
    if (typeof chart.legend === "object") {
        let callback = function () {
            let legendID = chart.bocSettings.id + "-legend";
            // console.log("Event: " + event.type , event, chart.legend.contentHeight);
            document.getElementById(legendID).style.height = chart.legend.contentHeight + "px";
        };
        chart.legend.itemContainers.template.paddingTop = 0;
        chart.legend.itemContainers.template.paddingBottom = 4;

        chart.legend.events.on("validated", callback);
        chart.legend.exporting.useWebFonts = false;


        chart.legend.markers.template.adapter.add("fill", function (fill, target) {
            if (target.dataItem.dataContext.halfHash) {


                let marker = target.children.getIndex(0);
                if (marker.className === "RoundedRectangle" && marker.fill) {
                    let solidOverlay = new am4core.RoundedRectangle();
                    solidOverlay.width = am4core.percent(100);
                    solidOverlay.height = am4core.percent(100);
                    let solidGradient = new am4core.LinearGradient();
                    solidGradient.addColor(marker.fill.stroke);
                    solidGradient.addColor(marker.fill.stroke, 1, 0.5);
                    solidGradient.addColor(am4core.color("#000"), 0, 0.5);
                    solidOverlay.fill = solidGradient;
                    target.children.push(solidOverlay);
                    //adding striped overlay
                    let stripedOverlay = new am4core.RoundedRectangle();
                    stripedOverlay.width = am4core.percent(100);
                    stripedOverlay.height = am4core.percent(100);
                    let pattern = new am4core.LinePattern();
                    pattern.strokeWidth = marker.fill.strokeWidth;
                    pattern.gap = marker.fill.gap;
                    pattern.width = marker.fill.width;
                    pattern.height = marker.fill.height;
                    pattern.rotation = marker.fill.rotation;
                    pattern.stroke = marker.fill.stroke;
                    pattern.strokeOpacity = marker.fill.strokeOpacity;
                    pattern.shapeRendering = marker.fill.shapeRendering;
                    stripedOverlay.fill = pattern;

                    target.children.push(stripedOverlay);
                }
                target.processed = true;
            }

            return fill;
        });

        chart.legend.itemContainers.template.events.on('toggled', (ev) => {
            setTimeout(function () {
                const toggledSeries = ev.target.dataItem.dataContext;
                const yAxis = toggledSeries.yAxis;
                const seriesWithSameYAxis = chart.series.values.filter((series) => series.yAxis === yAxis);
                const isAllHidden = seriesWithSameYAxis.every((series) => {
                    return series.isHidden || series.isHiding || !series.visible;
                });
                if (typeof yAxis !== "undefined") {
                    yAxis.disabled = !!isAllHidden;
                }
            }, 10);

            if (typeof gaVars === 'object') {
                let chartTitle = bocAmchart4.getChartTitle(chart);
                let chartID = chart.bocSettings.id;
                let eventAction;
                if (chart.bocSettings.type === 'pie') {
                    eventAction = ev.target.isActive ? "legend_series_hidden" : "legend_series_shown";
                } else {
                    eventAction = ev.target.dataItem.dataContext.isHidden ? "legend_series_shown" : "legend_series_hidden";
                }

                const seriesName = ev.target.dataItem.name;
                gtag('event', eventAction, {
                    'event_category': 'AmCharts4',
                    'event_label': chartTitle,
                    'event_chart': chartID,
                    'event_series': seriesName
                });
            }
        });

        chart.exporting.extraSprites.push({
            "position": "bottom",
            "sprite": chart.legend.parent
        });
    }

    if (typeof chart.yAxes === "object") {
        chart.yAxes.values.forEach(function (axis) {
            bocAmchart4.processAxesParams(chart, axis);
        });
    }

    if (typeof chart.xAxes === "object") {
        chart.xAxes.values.forEach(function (axis) {
            bocAmchart4.processAxesParams(chart, axis);
        });
    }

    let titlesId = chart.bocSettings.id + "-titles";
    let targetTitlesId = false;
    let titlesContainer = bocAmchart4.vars[chart.bocSettings.id].titlesContainer;

    if (chart.bocSettings.args.hasOwnProperty("matchtitlesheighttarget")) {
        let targetChartId = "amchart" + chart.bocSettings.args["matchtitlesheighttarget"];
        targetTitlesId = targetChartId +  "-titles";
        document.getElementById(targetTitlesId).dataset.externallyControlled = chart.bocSettings.id;
    }

    let titlesCallback = function () {
        if (document.getElementById(titlesId).dataset.externallyControlled) {
            let sourceChartId = document.getElementById(titlesId).dataset.externallyControlled;
            let sourceTitlesContainer = bocAmchart4.vars[sourceChartId].titlesContainer;
            document.getElementById(titlesId).style.height = sourceTitlesContainer.contentHeight + "px";
        } else {
            document.getElementById(titlesId).style.height = titlesContainer.contentHeight + "px";
            if (titlesContainer.children && titlesContainer.children.length === 0) {
                titlesContainer.htmlContainer.style.height = "1px";
            }
        }
    };

    titlesContainer.events.on("validated", titlesCallback);
    titlesContainer.events.on("maxsizechanged", titlesCallback);
    chart.events.on("datavalidated", titlesCallback);


    if (chart.bocSettings.args.hasOwnProperty("note")
        || chart.bocSettings.args.hasOwnProperty("lastobservation")) {
        let notesId = chart.bocSettings.id + "-notes";
        let notesContainer = bocAmchart4.vars[chart.bocSettings.id].notesContainer;
        let notesCallback = function () {
            document.getElementById(notesId).style.height = notesContainer.contentHeight + "px";
            if (document.getElementById(notesId).style.maxHeight !== ""
                && document.getElementById(notesId).style.maxHeight !== "0px") {
                document.getElementById(notesId).style.maxHeight = notesContainer.contentHeight + "px";
            }
            bocAmchart4.vars[chart.bocSettings.id].notesHeight = document.getElementById(notesId).style.height;
        };

        notesContainer.events.on("validated", notesCallback);
        notesContainer.events.on("maxsizechanged", notesCallback);
        chart.events.on("datavalidated", notesCallback);
        notesContainer.exporting.useWebFonts = false;

        chart.exporting.extraSprites.push({
            "position": "bottom",
            "sprite": notesContainer
        });
        chart.exporting.validateSprites.push(notesContainer);
    }

    if (typeof chart.yAxes === "object") {
        chart.yAxes.values.forEach(function (axis) {
            if (bocAmchart4.debug(chart)) {
                axis.events.onAll(function (eventName, event) {
                    // eslint-disable-next-line no-console
                    console.debug("chart yAxis events:", eventName, event);
                });
            }
            if (axis._className === "ValueAxis") {
                axis.events.on("extremeschanged", function (ev) {
                    ev.target.events.once("datarangechanged", function (event) {
                        if (event.target.syncWithAxis === undefined) {
                            event.target.zoom({start: 0, end: 1}, true);
                        }
                    });
                });
            }
        });
    }
    if (typeof chart.xAxes === "object") {
        chart.xAxes.values.forEach(function (axis) {
            if (bocAmchart4.debug(chart)) {
                axis.events.onAll(function (eventName, event) {
                    // eslint-disable-next-line no-console
                    console.debug("chart xAxis events:", eventName, event);
                });
            }
            if (axis._className === "ValueAxis") {
                axis.events.on("extremeschanged", function (ev) {
                    ev.target.events.once("datarangechanged", function (event) {
                        event.target.zoom({start: 0, end: 1}, true);
                    });
                });
            }
            if (axis._className === 'DateAxis') {
                let period = 'day';
                if (chart.bocSettings.args.hasOwnProperty("period")) {
                    period = chart.bocSettings.args.period;
                }
                switch (period) {
                    case "day":
                        axis.baseInterval = {
                            timeUnit: "day",
                            count: 1
                        };
                        // Use a different distance to prevent label overlap
                        axis.renderer.minGridDistance = 4.75 * bocAmchart4.remPixels;
                        axis.dateFormats.setKey('month', "MMM yyyy");

                        if (chartLanguage === "fr") {
                            axis.dateFormats.setKey('day', "d MMM yyyy");
                            axis.periodChangeDateFormats.setKey('day', "d MMM yyyy");
                        } else {
                            axis.dateFormats.setKey('day', "MMM d',' yyyy");
                            axis.periodChangeDateFormats.setKey('day', "MMM d',' yyyy");
                        }
                        break;
                    case "month":
                        axis.baseInterval = {
                            timeUnit: "month",
                            count: 1
                        };
                        axis.dateFormats.setKey('month', "MMM yyyy");
                        axis.periodChangeDateFormats.setKey('month', "MMM yyyy");
                        break;
                    case "quarter":
                        axis.baseInterval = {
                            timeUnit: "month",
                            count: 3
                        };
                        if (chartLanguage === "fr") {
                            axis.dateFormats.setKey('month', "yyyy'T'q");
                            axis.periodChangeDateFormats.setKey('month', "yyyy'T'q");
                        } else {
                            axis.dateFormats.setKey('month', "yyyy'Q'q");
                            axis.periodChangeDateFormats.setKey('month', "yyyy'Q'q");
                        }
                        break;
                    case "year":
                        axis.baseInterval = {
                            timeUnit: "year",
                            count: 1
                        };
                        axis.dateFormats.setKey('month', "yyyy");
                        axis.periodChangeDateFormats.setKey('month', "yyyy");
                        break;
                    default:
                        if (period.includes('MM')) {
                            axis.baseInterval = {
                                timeUnit: "month",
                                count: parseInt(period.substring(0, period.indexOf("M")))
                            };
                            // Use a different distance to prevent label overlap
                            axis.renderer.minGridDistance = 5 * bocAmchart4.remPixels;

                            if (chartLanguage === "fr") {
                                axis.dateFormats.setKey('month', "d MMM yyyy");
                                axis.periodChangeDateFormats.setKey('month', "d MMM yyyy");
                            } else {
                                axis.dateFormats.setKey('month', "MMM d',' yyyy");
                                axis.periodChangeDateFormats.setKey('month', "MMM d',' yyyy");
                            }
                        } else if (period.includes('DD')) {
                            axis.baseInterval = {
                                timeUnit: "day",
                                count: parseInt(period.substring(0, period.indexOf("D")))
                            };
                            // Use a different distance to prevent label overlap
                            axis.renderer.minGridDistance = 4.75 * bocAmchart4.remPixels;
                            axis.dateFormats.setKey('month', "MMM yyyy");

                            if (chartLanguage === "fr") {
                                axis.dateFormats.setKey('day', "d MMM yyyy");
                                axis.periodChangeDateFormats.setKey('day', "d MMM yyyy");
                            } else {
                                axis.dateFormats.setKey('day', "MMM d',' yyyy");
                                axis.periodChangeDateFormats.setKey('day', "MMM d',' yyyy");
                            }
                        }
                }
                // Lowercase the DateAxis labels in French
                if (chartLanguage === "fr" && chart.bocSettings.args.period !== 'quarter') {
                    axis.renderer.labels.template.adapter.add("text", function (text, target) {
                        if (typeof text !== 'undefined' && !target.hasOwnProperty('belongs')) {
                            text = text.replace(/^1(?=\s)/, "1[baseline-shift: super; font-size: 10;]er[/]");
                            return text.toLowerCase();
                        } else {
                            return text;
                        }
                    });
                }
            }
            if (axis._className === 'DurationAxis') {
                axis.baseUnit = "second";
                axis.durationFormatter.durationFormat = "hh:mm"
                if (chartLanguage === "fr") {
                    axis.durationFormatter.durationFormat = "hh'h'mm";
                }
            }
        });
    }

    titlesContainer.exporting.useWebFonts = false;
    chart.exporting.extraSprites.push({
        "position": "top",
        "sprite": titlesContainer
    });


    bocAmchart4.setGuidesFromShortcode(chart);
    bocAmchart4.modifyChartForPrint(chart);

    if (chart.bocSettings.args.hasOwnProperty("skipdataloading")) {
        // possibly not optimal, but seems to work in all scenarios
        chart.events.once("layoutvalidated", function () {
            let repeater = setInterval(function () {
                if (document.hidden) {
                    return;
                }
                clearInterval(repeater);
                var event = {
                    'target': {
                        'component': chart,
                        'data': {}
                    }
                };
                bocAmchart4.whichPostProcessor(chart)(event);
                chart.data = event.target.data;
            }, 100);
        });
    }


    if (bocAmchart4.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "After applyBosSettingsObject for",
            bocAmchart4.debugClone(chart)
        );
        chart.xAxes.getIndex(0).events.onAll(function (eventName, event) {
            // eslint-disable-next-line no-console
            console.debug("xAxes", eventName, event);
        });
    }
};

bocAmchart4.processAxesParams = function (chart, axis) {
    // Always show axis line
    if (axis.axisLetter === "Y") {
        axis.renderer.line.strokeOpacity = 0.15;
    }

    // Disable the axis tooltips by default
    axis.cursorTooltipEnabled = false;
    if (chart.bocSettings.args.hasOwnProperty(axis.id + "axisenabletooltips") &&
        chart.bocSettings.args[axis.id + 'axisenabletooltips'] === "true") {
        axis.cursorTooltipEnabled = true;
    }

    if (axis._className === 'DateAxis') {
        axis.cursorTooltipEnabled = true;

        // Lowercase the DateAxis cursor tooltip and update the 1st day of the month for French
        if (chartLanguage === "fr" && chart.bocSettings.args.period !== 'quarter') {
            axis.tooltip.label.adapter.add("text", function (text) {
                if (typeof text !== 'undefined') {
                    text = text.replace(/^1(?=\s)/, "1[baseline-shift: super; font-size: 10;]er[/]");
                    return text.toLowerCase();
                }
            });
        }

        if (chart.bocSettings.args.hasOwnProperty(axis.id + "axisenabletooltips") &&
            chart.bocSettings.args[axis.id + 'axisenabletooltips'] === "false") {
            axis.cursorTooltipEnabled = false;
        }

        if (chart.bocSettings.args.hasOwnProperty("skipemptyperiods") &&
            chart.bocSettings.args["skipemptyperiods"] === "true") {
            axis.skipEmptyPeriods = true;
        }
    }
    if (chart.bocSettings.args.hasOwnProperty(axis.id + "axisminimum")) {
        axis.min = parseFloat(chart.bocSettings.args[axis.id + "axisminimum"]);
    }

    if (chart.bocSettings.args.hasOwnProperty(axis.id + "axismaximum")) {
        axis.max = parseFloat(chart.bocSettings.args[axis.id + "axismaximum"]);
    }

    if (chart.bocSettings.args.hasOwnProperty(axis.id + "axisstrictminmax") &&
        chart.bocSettings.args[axis.id + "axisstrictminmax"] === "true") {
        axis.strictMinMax = true;
    }

    if (chart.bocSettings.args.hasOwnProperty(axis.id + "axishidelabels")
        && chart.bocSettings.args[axis.id + "axishidelabels"] === 'true') {
        chart.events.on('validated', function () {
            axis.visible = false;
            if (axis.axisLetter === "X") {
                axis.height = 0;
            }
            if (axis.axisLetter === "Y") {
                axis.width = 0;
            }
        });
    }

    if (axis.axisLetter === "X") {
        chart.bottomAxesContainer.events.on('sizechanged', function (event) {
            axis.title.maxWidth = event.target.innerWidth;
            chart.bottomAxesContainer.invalidateLabels();
            if (chart.bocSettings.args.hasOwnProperty("bottomaxistitle")) {
                if (chart.xAxes.getIndex(0).title.currentText) {
                    axis.deepInvalidate();
                }
            }
        });
    }
    if (axis.axisLetter === "Y") {
        chart.chartContainer.events.on('sizechanged', function () {
            chart.yAxesAndPlotContainer.invalidateLabels();
        });
    }

    if (chart.bocSettings.args.hasOwnProperty(axis.id + "axismingriddistance")) {
        axis.renderer.minGridDistance = parseInt(chart.bocSettings.args[axis.id + "axismingriddistance"]);
    }
    if (chart.bocSettings.args.hasOwnProperty(axis.id + "axisunit")) {
        let unit = chart.bocSettings.args[axis.id + "axisunit"];
        axis.renderer.labels.template.adapter.add("text", function (label, target) {
            if (label && target.belongs === undefined) {
                if (chart.bocSettings.args.hasOwnProperty(axis.id + "axisunitfirst") &&
                    chart.bocSettings.args[axis.id + 'axisunitfirst'] === "true") {
                    return unit + label;
                } else {
                    return label + unit;
                }
            } else {
                return label;
            }
        });
    }
    if (chart.bocSettings.args.hasOwnProperty(axis.id + 'axisstacktype') &&
        chart.bocSettings.args[axis.id + 'axisstacktype'] === "100%") {
        axis.calculateTotals = true;
        axis.min = 0;
        axis.max = 100;
        axis.strictMinMax = true;
    }

    if (chart.bocSettings.args.hasOwnProperty(axis.id + 'axismaxprecision')) {
        axis.maxPrecision = parseInt(chart.bocSettings.args[axis.id + 'axismaxprecision']);
    }

    if (chart.bocSettings.args.hasOwnProperty('axissyncprimary')) {
        if (axis.id === chart.bocSettings.args['axissyncprimary']) {
            let targetIdx = axis.id === 'left' ? 1 : 0;
            let primaryIdx = 1 - targetIdx;
            chart.yAxes.getIndex(targetIdx).syncWithAxis = chart.yAxes.getIndex(primaryIdx);
        }
    }

    if (chart.bocSettings.args.hasOwnProperty(axis.id + 'axisextramax')) {
        axis.extraMax = parseFloat(chart.bocSettings.args[axis.id + 'axisextramax']);
    }

    if (chart.bocSettings.args.hasOwnProperty(axis.id + 'axisextramin')) {
        axis.extraMin = parseFloat(chart.bocSettings.args[axis.id + 'axisextramin']);
    }

    if (chart.bocSettings.args.hasOwnProperty(axis.id + 'axisfullheightcolumns')
        && chart.bocSettings.args[axis.id + 'axisfullheightcolumns'] === 'true') {
        chart.events.on("datavalidated", function () {
            bocAmchart4.setMinMaxForColumns(chart, axis);
        });
    }

    if (chart.bocSettings.args.hasOwnProperty(axis.id + 'axisreversed') &&
        chart.bocSettings.args[axis.id + 'axisreversed'] === "true") {
        axis.renderer.inversed = true;
        if (axis.axisLetter === "Y") {
            axis.title.rotation = -90;
        }
    }

    axis.invalidate();
};
